import { Injectable, Signal, signal } from '@angular/core';
import { GeoCoordinates } from '@fmnts/api';
import { DeclarativeGeolocationService } from '@fmnts/declarative-forms/geolocation';
import { Option } from 'effect';
import { EMPTY, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NoopGeolocationService extends DeclarativeGeolocationService {
  override coordinates: Signal<Option.Option<GeoCoordinates>> = signal(
    Option.none(),
  );
  override canImproveAccuracy: Signal<boolean> = signal(false);
  override latestCoordinates$: Observable<GeoCoordinates> = EMPTY;
  override updatePosition(): void {}
}
